module.exports = __webpack_public_path__ + "static/lageplan_kinderbetreuung-5611cf6b0a5423813dcddfb54f7a94f3.png";